//Search
export const IDI_INSPECTION_SEARCH_START_LOADING = "IDI_INSPECTION_SEARCH_START_LOADING";
export const IDI_INSPECTION_SEARCH_END_LOADING = "IDI_INSPECTION_SEARCH_END_LOADING";
export const IDI_INSPECTION_SEARCH_LOADED = "IDI_INSPECTION_SEARCH_LOADED";
export const SET_IDI_INSPECTION_FILTER = "SET_IDI_INSPECTION_FILTER";

//Edit
export const IDI_INSPECTION_START_LOADING = "IDI_INSPECTION_START_LOADING";
export const IDI_INSPECTION_END_LOADING = "IDI_INSPECTION_END_LOADING";
export const IDI_INSPECTION_LOADED = "IDI_INSPECTION_LOADED";